import axios from './axios-replacement';

export const uploadImg = (formData, success, error) => {
    return axios.patch('/rest/images/verification', formData).then(res => {
        if(res.data.result == 'SUCCESS') {
            success && success(res.data)
        } else {
            error && error(res.data)
        }
    }, (err) => {
        error && error(err.data)
    })
}

/*
* KOL认证通道
* */
export const postUserInfo = (data, success, error) => {
    return axios.post('/rest/verification/userinfo', data).then(res => {
        if(res.data.result == 'SUCCESS') {
            success && success(res.data)
        } else {
            error && error(res.data)
        }
    }, (err) => {
        error && error(err.data)
    })
}

/*
* 培训班申请认证特殊通道
* */
export const postTrainInfo = (data, success, error) => {
    return axios.post('/rest/verification/userinfo/train', data).then(res => {
        if(res.data.result == 'SUCCESS') {
            success && success(res.data)
        } else {
            error && error(res.data)
        }
    }, (err) => {
        error && error(err.data)
    })
}

/*
* 付费课程申请垂类认证 特殊通道
* */
export const postCourseUserInfo = (data, success, error) => {
    return axios.post('/gapi/misc/verify/vertical/apply/paid-course', data).then(res => {
        if(res.data.result == 'SUCCESS') {
            success && success(res.data)
        } else {
            error && error(res.data)
        }
    }, (err) => {
        error && error(err.data)
    })
}

/*
* 检查申请权限接口: 购买了付费课程，才能获得申请认证的机会
* */
export const getPaidCourseVerticalCheck = (data, success, error) => {
    return axios.get('/gapi/misc/verify/vertical/check/paid-course', { params: data }).then(res => {
        if(res.data.result == 'SUCCESS') {
            success && success(res.data)
        } else {
            error && error(res.data)
        }
    }, (err) => {
        error && error(err.data)
    })
}
